function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { Button } from './Button';
export function FilterButton(_ref) {
  let {
    text = 'Apply',
    type = 'button',
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Button, _extends({
    icon: "filter_alt",
    variant: "primary",
    type: type
  }, props), text);
}